(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herp-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      this.current = 0;
      this.timer = null;
      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;

      if (this.slides.length <= 1) return;

      // Bind so we can remove listeners on disconnect
      this._onPrev = () => this.prev();
      this._onNext = () => this.next();
      this._onEnter = () => this.stop();
      this._onLeave = () => this.start();

      this.prevBtn = this.querySelector('[data-slideshow-prev]');
      this.nextBtn = this.querySelector('[data-slideshow-next]');
      this.prevBtn && this.prevBtn.addEventListener('click', this._onPrev);
      this.nextBtn && this.nextBtn.addEventListener('click', this._onNext);

      this.dots.forEach((dot) => {
        dot._handler = () => this.goTo(parseInt(dot.dataset.slideTo, 10));
        dot.addEventListener('click', dot._handler);
      });

      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.prevBtn && this.prevBtn.removeEventListener('click', this._onPrev);
      this.nextBtn && this.nextBtn.removeEventListener('click', this._onNext);
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
    }

    goTo(index) {
      const total = this.slides.length;
      const next = (index + total) % total;

      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.dots[this.current] && this.dots[this.current].classList.remove('is-active');

      this.slides[next].classList.add('is-active');
      this.slides[next].removeAttribute('aria-hidden');
      this.dots[next] && this.dots[next].classList.add('is-active');

      this.current = next;
    }

    next() { this.goTo(this.current + 1); }
    prev() { this.goTo(this.current - 1); }

    start() {
      if (!this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.next(), this.speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
